$('.tabs').addClass('js-tabs');
$('.js-tabs .tabs__article').addClass('js-tabs__article');
$('.js-tabs .tabs__nav').addClass('js-tabs__nav');
$('.js-tabs .tabs__body').addClass('js-tabs__body');

var $tabs = $('.tabs'),
	hashStack = [];

global.updateTabsSelectors = function () {
	$tabs = $('.tabs');
};

global.getTabHash = function () {
	const data = {};
	data.hash = window.location.hash.split('!');
	data.href = data.hash[0];
	data.ePath = data.hash[1];
	data.name = data.href.substr(1);
	data.type = undefined;

	if ($tabs.find(`.tabs__button[href="${data.href}"]`).length) {
		data.type = 'tabs';
	}

	return data;
};

function checkHash(options) {
	var data = global.getTabHash();

	openParents(data);

	if (data.type === 'tabs') {
		openTabs(data, options.scroll);
	}
}

function openParents(data) {
	const $parents = $(`[href="${data.href}"]`).parents('.js-tabs__article');
	$parents.each(function (index) {
		var $this = $(this);
		if ($this.hasClass('js-tabs__article')) {
			var name = $this.attr('data-tab');
			openTabs({href: '#' + name,	name: name});
		}
	});
}

function openTabs(data, scroll) {
	var $thisTabs = $tabs.find(`a[href="${data.href}"]`).closest('.js-tabs');

	$thisTabs
		.children('.js-tabs__nav')
		.find('.tabs__button')
		.removeClass('is-expand')
		.closest(`a[href="${data.href}"]`)
		.addClass('is-expand')
		.closest('.js-tabs')
		.children('.js-tabs__body')
		.children('.js-tabs__article')
		.removeClass('is-expand')
		.closest(`[data-tab="${data.name}"]`)
		.addClass('is-expand');

	if (scroll) {
		setTimeout(function () {
			scrollToElement(data.href);
		}, 0);
	}
}

function scrollToElement(href) {
	var topPos = $(`[href="${href}"]`).offset().top;
	$('html')
		.velocity('scroll', {
			offset: topPos + 'px',
			duration: 500,
			mobileHA: false
		});
}

function tabs() {
	$tabs.each(function (index, el) {
		const $this = $(el);
		const $showTab = $this.attr('data-show-tab');
		const href = ($showTab !== undefined && $tabs.find(`.accordion__button[href="#${showTab}"]`).length) ?
			('#' + $showTab) :
			$this.find('.tabs__button').eq(0).attr('href');
		const name = href.substr(1);

		openTabs({href, name});
	});
}

tabs();

checkHash({scroll: true});

$(window).on('hashchange', checkHash);



// WEBPACK FOOTER //
// ./temp/components/tabs/index.js